// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2fz5V","title":"BackImages_title__EZ99a","images":"BackImages_images__2zv4v"};